<template>
    <footer class="bg-gray-50">
        <div class="mx-auto max-w-screen-xl px-12 py-6">
            <p class="text-center text-gray-500">© 2023-2024 My Portfolio. All Rights Reserved.</p>
        </div>
    </footer>
</template>